import React from "react"

import moment from "moment"

import BaseTable from "./BaseTable"

export default class TerminalOrderLineItemsTable extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      live: props.live,
      terminalOrder: props.terminalOrder,
    }

    this.table = React.createRef()
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      ...nextProps,
    }, () => this.table.current.refresh())
  }


  _getColumns() {
    return [
      {
        Header: 'Date',
        id: 'created_at',
        accessor: lineItem => moment(lineItem.created_at).format('DD MMM YYYY')
      },
      {
        Header: 'Device Model',
        id: 'name',
        accessor:  lineItem => lineItem.name
      },
      {
        Header: 'Quantity',
        id: 'quantity',
        accessor:  lineItem => lineItem.quantity
      },
    ]
  }

  render() {
    let {
      terminalOrder,
    } = this.state

    const columns = this._getColumns()

    let endpoint = `${window.Api.TerminalOrderLineItems}?order_id=${terminalOrder?.id || ""}`

    return (
      <div>
        <BaseTable
          ref={this.table}
          endpoint={`${endpoint}`}
          noDataMessage={"No Line Items Found"}
          title={""}
          columns={columns}
          showSearch={false}
          showExport={false}
          showHeader={false}
          defaultSorted={[
            {
              id: "created_at",
              desc: true
            }
          ]}
        />
      </div>
    )
  }
}

TerminalOrderLineItemsTable.defaultProps = {
  latestResults: false
}
